import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ClaimDocumentService } from 'src/app/core/services/claim_document.service';
import {
  DocumentType,
  KycProvider,
  KycService,
} from 'src/app/core/services/kyc.service';
import { PersonalDocumentService } from 'src/app/core/services/personal_document.service';
import { UserService } from 'src/app/core/services/user.service';
import { BaseKycProviderComponent } from './base-kyc-provider.component';
import { KycDataService } from 'src/app/modules/client/pages/guide/services/kyc-data.service';
import { KycFileValidationService } from './services/kyc-file-validation.service';
import { KycMessageService } from './services/kyc-message.service';
import { TranslateService } from '@ngx-translate/core';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { ActionPollingService } from 'src/app/modules/client/pages/guide/services/action-polling.service';

export enum DocumentTypeEnum {
  PASSPORT = 'passport',
  NATIONAL_IDENTITY_CARD = 'national_identity_card',
  RESIDENCE_PERMIT = 'residence_permit',
  OTHER_IDENTITY_DOCUMENT = 'other_identity_document',
  DRIVER_LICENSE = 'driving_licence',
  // Tipos específicos do Veriff
  ID_CARD = 'id_card',
  DRIVERS_LICENSE = 'drivers_license',
  UNKNOWN = 'unknown',
}
export enum ProcessingStatus {
  PROCESSING = 'PROCESSING',
  END_PROCESSING = 'END_PROCESSING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface KycCheckBody {
  provider: KycProvider;
  documentType: DocumentType;
  user_id: string;
  front_id?: string;
  back_id?: string;
  action_id?: string;
  // CPK-4012: bind the check to its claim so the completion gate is per-claim.
  claim_id?: string;
  providerAdditionalInfo?: {
    [key: string]: any;
  };
}

@Component({
  selector: 'app-document-kyc-upload-modal',
  templateUrl: './base-kyc-provider.component.html',
  styleUrls: ['./base-kyc-provider.component.scss'],
})
export class DocumentKycUploadModalComponent extends BaseKycProviderComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    dialog: MatDialog,
    pds: PersonalDocumentService,
    cds: ClaimDocumentService,
    ks: KycService,
    us: UserService,
    dialogRef: MatDialogRef<DocumentKycUploadModalComponent>,
    kycService: KycDataService,
    validationService: KycFileValidationService,
    messageService: KycMessageService,
    translate: TranslateService,
    claimsService: ClaimsService,
    actionPollingService: ActionPollingService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    const serviceData = kycService.getData();
    if (serviceData != null) {
      data = serviceData;
    }
    super(
      data,
      dialog,
      pds,
      cds,
      ks,
      us,
      dialogRef,
      kycService,
      validationService,
      messageService,
      translate,
      claimsService,
      actionPollingService,
      router,
      activatedRoute
    );
    if (!data.provider) data.provider = 'verifflite';
    console.log('data provider', data.provider);
  }
}
